




export default {
  props: {
    size: {
      required: false,
      type: String,
      default: '30px',
    },
  },
  name: 'MyLoadingIcon',
};
